import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import localeText from "../../../../locale";
import { formatPrice } from "../../../../utilities/formatPrice";
import { formatAddress } from "../ThankYouPage/ThankYouPage";
import "./Shipping.css";
import { useEffect, useRef, useState } from "react";
import { InputNumber } from "primereact/inputnumber";
import { FileUpload } from "primereact/fileupload";
import OrderService from "../../../../service/OrderService";
import { Toast } from "primereact/toast";
import CheckoutAddressDialog from "../CheckoutAddressDialog/CheckoutAddressDialog";
import UserInfoDialog from "../UserInfoDialog/UserInfoDialog";
import { set } from "@cloudinary/url-gen/actions/variable";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";
import { Link } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { Tooltip } from "primereact/tooltip";
import { useLocation } from "react-router-dom";
import Shipping from "./Shipping";
import useCheckout from "../Checkout/hooks/useCheckout";
import ProductRow from "../Checkout/ProductRow";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import UnifiedOrderSummary from "../UnifiedOrderSummary/UnifiedOrderSummary";
import { usePayment } from "../Checkout/context/PaymentContext";
import { removelocalStorageToken } from "../../../../utilities/sessionStorage/token";
import { removelocalStorageUsername } from "../../../../utilities/sessionStorage/username";

const ShippingCheckout = ({
  cashback,
  order,
  orderItems,
  setOrder,
  currencyProduct,
  currencyCodeUser,
  currencyUser,
  setAmountTransfer,
  currencyExchangeValue,
  setPrice,
  amountWallet,
  walletBalance,
  walletBalanceForex,
  price,
  amountBankTransfer,
  setAmountBankTransfer,
  bankTransferReceipt,
  setBankTransferReceipt,
  amountToPayWithExtracredit,
  setAmountToPayWithExtracredit,
  currencyCode,
  setAmountWallet,
  walletExtracoinBalance,
  userInfo,
  setUserInfo,
  userPercentExtracoin,
  setAddressInfo,
  setPriceForex,
  setDisplayPaymentModal,
  sendMethod,
  setSendMethod,
  walletExtracoinBalanceForex,
  setAmountShipmentForexProduct,
  amountShipmentForexProduct,
  setLoading,
}) => {
  const {
    loading,
    amountShipmentForexUser,
    postalCode,
    shippingQuotes,
    isFreeFreight,
    number,
    setAddressValues,
    showMessageSellerResponsibility,
    country,
    checkZipCode,
    state,
    city,
    district,
    address,
    isLoadingFreight,
    toggleIsPickup,
    isPickup,
    setIsPickup,
    setNewCompleteAddress,
  } = useCheckout({
    setAddressInfo,
    setPriceForex,
    setDisplayPaymentModal,
    setAmountShipmentForexProduct,
    setAmountTransfer,
  });
  const { page, setPage, setSendMethod: setPaymentSendMethod } = usePayment();
  const orderService = new OrderService();
  const getUserInfoService = new GetUserInfoService();
  const userInfoService = new GetUserInfoService();

  const { showErrorToast } = useToastContext();

  useEffect(() => {
    if (sendMethod) {
      setSendMethod(null);
      setPaymentSendMethod(null);
    }
  }, []);

  useEffect(() => {
    const savedIsPickup = localStorage.getItem("__extraconomy_isPickup");
    if (savedIsPickup === "true") {
      setIsPickup(false);
      localStorage.setItem("__extraconomy_isPickup", "false");
    }
  }, [setIsPickup]);

  useEffect(() => {
    if (sendMethod) {
      setPaymentSendMethod(sendMethod);
    }
  }, [sendMethod, setPaymentSendMethod]);

  const history = useHistory();

  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const [currentSection, setCurrentSection] = useState("address");
  const [autoCurrentSection, setAutoCurrentSection] = useState(false);

  const toast = useRef(null);
  const fileUploadRef = useRef(null);

  const [showCheckoutAddressDialog, setShowCheckoutAddressDialog] = useState(false);
  const [showUserInfoDialog, setShowUserInfoDialog] = useState(false);

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const currencyFormat = {
    USD: "$",
    EUR: "€",
    BRL: "R$",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "AU$",
    CAD: "CA$",
    CHF: "CHF",
  };

  const orderCurrency = isFringeBenefitsPage
    ? order?.fringeBenefit?.currency
    : order?.itens?.[0]?.product?.currency || currencyProduct; // Added fallback to currencyProduct

  const handleShowCheckoutAddressDialog = () => {
    setShowCheckoutAddressDialog(true);
  };

  const handleShowUserInfoDialog = () => {
    setShowUserInfoDialog(true);
  };

  const handleUserInfoSuccess = (updatedUserInfo) => {
    if (updatedUserInfo) {
      const mergedUserInfo = {
        ...(userInfo || {}),
        ...updatedUserInfo,
      };
      setUserInfo(mergedUserInfo);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const hasValidAddress =
      userInfo &&
      userInfo.address &&
      userInfo.city &&
      userInfo.country &&
      userInfo.district &&
      userInfo.number &&
      userInfo.postalCode &&
      userInfo.state;

    const hasNoExistingAddress = !address && !city && !district && !number && !postalCode && !state;

    if (hasValidAddress && hasNoExistingAddress) {
      setNewCompleteAddress(
        userInfo.address || "",
        userInfo.city || "",
        userInfo.country || "IT",
        userInfo.district || "",
        userInfo.number || "",
        userInfo.postalCode || "",
        userInfo.state || ""
      );
    }
  }, [userInfo, address, city, district, number, postalCode, state, setNewCompleteAddress]);

  const handleCompleteForm = () => {
    if (
      address &&
      city &&
      country &&
      district &&
      number &&
      postalCode &&
      state &&
      !autoCurrentSection
    ) {
      setCurrentSection("shipping");
      setAutoCurrentSection(true);
    }
  };

  const setAddressInfoDialog = (event) => {
    handleCompleteForm();
    setNewCompleteAddress(
      event.address,
      event.city,
      event.country || country || userInfo?.country || "IT",
      event.district,
      event.number,
      event.postalCode,
      event.state
    );
  };

  const uploadFile = async (event) => {
    if (event.files[0].size / 1024 / 1024 > 5) {
      fileUploadRef.current.clear();
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("fileSizeTooBig"),
        life: 6000,
      });
      return false;
    }
    try {
      const res = await orderService.setBankTransferReceipt(event.files[0]);
      setBankTransferReceipt(res.result);
    } catch (error) {
      if (error.status === 401 || error.status === 403) {
        removelocalStorageToken();
        removelocalStorageUsername();
        window.location.replace("/login");
      }
    }
  };

  const hasCompleteAddress = () => {
    const complete = !!(address && city && country && district && number && postalCode && state);
    return complete;
  };

  useEffect(() => {
    if (hasCompleteAddress()) {
      handleCompleteForm();
    }
  }, [address, city, country, district, number, postalCode, state]);

  useEffect(() => {
    if (!isFringeBenefitsPage)
      autoCurrentSection &&
        setNewCompleteAddress(address, city, country, district, number, postalCode, state); // eslint-disable-next-line
  }, [autoCurrentSection]);

  const orderTotal = isFringeBenefitsPage ? order.totalOrder : order.amountTotal;

  const maxInputAmountWallet =
    (isFringeBenefitsPage
      ? 0
      : sendMethod?.currency !== currencyProduct
      ? amountShipmentForexProduct
      : order.amountShipment) +
    orderTotal -
    amountToPayWithExtracredit;

  const walletBalanceValue =
    currencyCodeUser !== orderCurrency ? walletBalanceForex : walletBalance;

  const maxInputAmountExtracredit =
    (isFringeBenefitsPage
      ? 0
      : sendMethod?.currency !== currencyProduct
      ? amountShipmentForexProduct
      : order.amountShipment) +
    orderTotal -
    amountWallet;

  const maxInputAmountBankTransfer =
    (isFringeBenefitsPage
      ? 0
      : sendMethod?.currency !== currencyProduct
      ? amountShipmentForexProduct
      : order.amountShipment) +
    orderTotal -
    amountWallet -
    amountToPayWithExtracredit;

  let extracoinInWallet;

  if (walletExtracoinBalanceForex) {
    extracoinInWallet = walletExtracoinBalanceForex * (userPercentExtracoin / 100);
  } else {
    extracoinInWallet = walletExtracoinBalance * (userPercentExtracoin / 100);
  }

  const anyProductIsPickup = order?.itens?.some(
    (product) => product?.product?.shippingOption === "PICKUP"
  );
  const totarPrice =
    currencyProduct +
    " " +
    formatPrice(
      Math.abs(
        (isFringeBenefitsPage
          ? 0
          : sendMethod?.currency !== currencyProduct
          ? amountShipmentForexProduct
          : order.amountShipment) +
          orderTotal -
          amountWallet -
          amountToPayWithExtracredit
      )
    );

  return (
    <div className="pt-4 pb-8">
      <Toast ref={toast} />
      {(country || userInfo?.country || "IT") && (
        <CheckoutAddressDialog
          country={country || userInfo?.country || "IT"}
          visible={showCheckoutAddressDialog}
          checkZipCode={checkZipCode}
          onHide={() => setShowCheckoutAddressDialog(false)}
          onSubmit={setAddressInfoDialog}
        />
      )}
      <UserInfoDialog
        visible={showUserInfoDialog}
        onHide={() => setShowUserInfoDialog(false)}
        onSuccess={handleUserInfoSuccess}
        userInfo={userInfo}
      />

      <div
        className="font-bold text-xl my-3 flex gap-2 align-items-center justify-content-between"
        style={{ color: "#344563" }}
      >
        {localeText("confirmation")}{" "}
        <Button
          link
          className=" p-no-outline flex gap-2 align-items-center"
          style={{ color: "#245AE5" }}
          onClick={() => setPage(page - 1)}
        >
          <i className="pi pi-arrow-left text-xs"></i>{" "}
          <span className="underline">{localeText("backAction")}</span>
        </Button>
      </div>

      <div className="grid grid-nogutter gap-4">
        <div className="col-12 md:col-8 ">
          {!isFringeBenefitsPage &&
            !order?.itens?.[0]?.product?.downloadable &&
            !order?.itens?.[0]?.product?.service && (
              <div
                className="card p-4 border-round-lg border-none flex flex-column gap-3 mb-4"
                style={{ boxShadow: "0px 0px 40px  #5F58521A" }}
              >
                {!hasCompleteAddress() && (
                  <div className="flex flex-column gap-3">
                    <div className="font-bold" style={{ color: "#344563" }}>
                      {localeText("shipToMyAddress")}
                    </div>
                    <div className="flex justify-content-between">
                      <div className="flex gap-2 align-items-center">
                        <i className="pi pi-exclamation-circle" style={{ color: "#B3BAC5" }}></i>{" "}
                        <span className="text-sm" style={{ color: "#505F79" }}>
                          {localeText("youDontHaveAddress")}
                        </span>
                      </div>
                      <Button
                        link
                        label="+ Adicionar um endereço"
                        onClick={handleShowCheckoutAddressDialog}
                      />
                    </div>
                  </div>
                )}

                <div>
                  {hasCompleteAddress() && !isPickup && (
                    <div className="flex flex-column gap-3">
                      <div className="flex justify-content-between align-items-center">
                        <div className="font-bold" style={{ color: "#344563" }}>
                          {localeText("shipToMyAddress")}
                        </div>
                        <div>
                          <Button
                            className="text-sm p-no-outline"
                            style={{ color: "#7A869A" }}
                            link
                            icon="pi pi-pen-to-square"
                            label={localeText("modify")}
                            onClick={handleShowCheckoutAddressDialog}
                          />
                        </div>
                      </div>
                      <div className="flex flex-column gap-2">
                        <div className="flex gap-2 align-items-center">
                          <i className="pi pi-home" style={{ color: "#B3BAC5" }}></i>{" "}
                          <span className="text-sm" style={{ color: "#505F79" }}>
                            {address}, {number}
                          </span>
                        </div>
                        <div className="flex gap-2 align-items-center">
                          <i className="pi pi-map-marker" style={{ color: "#B3BAC5" }}></i>{" "}
                          <span className="text-sm" style={{ color: "#505F79" }}>
                            {city}, {state}, {country}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {anyProductIsPickup && (
                    <div>
                      {!isPickup && <hr></hr>}

                      <div className="flex align-items-center">
                        <Checkbox
                          inputId="ingredient1"
                          name="pizza"
                          value="Cheese"
                          onChange={toggleIsPickup}
                          checked={isPickup}
                        />
                        <label htmlFor="ingredient1" className="ml-2">
                          {localeText("pickUpInStore")}
                        </label>
                      </div>
                      {isPickup && (
                        <div className="text-sm mt-2">{formatAddress(order.seller)}</div>
                      )}
                    </div>
                  )}
                </div>

                {currentSection === "shipping" && !isPickup && (
                  <div>
                    <Button
                      className="text-sm border-none px-0 text-left p-no-outline"
                      link
                      onClick={() => {
                        setAddressValues();
                      }}
                      disabled={isLoadingFreight}
                      label={
                        isLoadingFreight
                          ? localeText("lookingTheBestShippingMethod")
                          : localeText("searchForShipping")
                      }
                    />
                    <div>
                      {isFreeFreight && (
                        <div className="text-sm" style={{ color: "#344563" }}>{`${localeText(
                          "freight"
                        )}: ${localeText("free")}`}</div>
                      )}
                      {showMessageSellerResponsibility && !sendMethod && !shippingQuotes && (
                        <div className="text-sm" style={{ color: "#ff6b6b", fontWeight: "500" }}>
                          ⚠️ Este vendedor não pode enviar para o seu endereço.
                        </div>
                      )}
                      {!isFringeBenefitsPage &&
                        !order?.itens?.[0]?.product?.service &&
                        !order?.itens?.[0]?.product?.downloadable &&
                        shippingQuotes &&
                        !isPickup && (
                          <Shipping
                            shippingQuotes={shippingQuotes}
                            postalCode={postalCode}
                            sendMethod={sendMethod}
                            setSendMethod={setSendMethod}
                          />
                        )}
                    </div>
                  </div>
                )}

                <hr className="my-4"></hr>

                <div className="flex flex-column gap-3">
                  <div className="font-bold" style={{ color: "#344563" }}>
                    {localeText("requiredUserInfo")}
                  </div>
                  {userInfo?.documentNumber &&
                    userInfo?.firstname &&
                    userInfo?.surname &&
                    userInfo?.phoneNumber && (
                      <div className="flex flex-column gap-2">
                        <div className="flex gap-2 align-items-center">
                          <i className="pi pi-user" style={{ color: "#B3BAC5" }}></i>{" "}
                          <span className="text-sm" style={{ color: "#505F79" }}>
                            {userInfo?.firstname} {userInfo?.surname}
                          </span>
                        </div>
                        <div className="flex gap-2 align-items-center">
                          <i className="pi pi-phone" style={{ color: "#B3BAC5" }}></i>{" "}
                          <span className="text-sm" style={{ color: "#505F79" }}>
                            {userInfo?.phoneNumber}
                          </span>
                        </div>
                        <div className="flex gap-2 align-items-center">
                          <i className="pi pi-id-card" style={{ color: "#B3BAC5" }}></i>{" "}
                          <span className="text-sm" style={{ color: "#505F79" }}>
                            {userInfo?.documentNumber}
                          </span>
                        </div>
                        <Button
                          className="text-sm border-none px-0 text-left p-no-outline"
                          link
                          onClick={handleShowUserInfoDialog}
                          label={localeText("modify")}
                        />
                      </div>
                    )}
                  {(!userInfo?.documentNumber ||
                    !userInfo?.firstname ||
                    !userInfo?.surname ||
                    !userInfo?.phoneNumber) && (
                    <>
                      <div className="text-sm" style={{ color: "#505F79" }}>
                        {localeText("fillRequiredUserInfoDescription")}
                      </div>
                      <Button
                        className="text-sm border-none px-0 text-left p-no-outline"
                        link
                        onClick={handleShowUserInfoDialog}
                        label={localeText("fillRequiredUserInfo")}
                      />
                    </>
                  )}
                </div>
              </div>
            )}

          <div
            className="card p-4 border-round-lg border-none"
            style={{ boxShadow: "0px 0px 40px  #5F58521A" }}
          >
            <div className="flex flex-column gap-4">
              {isFringeBenefitsPage ? (
                <ProductRow
                  index={0}
                  item={order}
                  orderItems={[]}
                  currencyFormat={currencyFormat}
                />
              ) : (
                <>
                  {orderItems.map((item, index) => (
                    <ProductRow
                      key={index}
                      index={index}
                      item={item}
                      orderItems={orderItems}
                      currencyFormat={currencyFormat}
                    />
                  ))}
                </>
              )}
            </div>
          </div>
        </div>

        <UnifiedOrderSummary
          context="checkout"
          order={order}
          isFringeBenefitsPage={isFringeBenefitsPage}
          currencyProduct={currencyProduct}
          currencyCodeUser={currencyCodeUser}
          sendMethod={sendMethod}
          shippingQuotes={shippingQuotes}
          showMessageSellerResponsibility={showMessageSellerResponsibility}
          amountShipmentForexUser={amountShipmentForexUser}
          currencyUser={currencyUser}
          currencyFormat={currencyFormat}
          walletExtracoinBalance={walletExtracoinBalance}
          currencyExchangeValue={currencyExchangeValue}
          orderTotal={orderTotal}
          userPercentExtracoin={userPercentExtracoin}
          walletExtracoinBalanceForex={walletExtracoinBalanceForex}
          orderCurrency={orderCurrency}
          walletBalance={walletBalance}
          amountToPayWithExtracredit={amountToPayWithExtracredit}
          setLoading={setLoading}
          maxInputAmountExtracredit={maxInputAmountExtracredit}
          extracoinInWallet={extracoinInWallet}
          amountShipmentForexProduct={amountShipmentForexProduct}
          setOrder={setOrder}
          setPrice={setPrice}
          orderKey={orderKey}
          amountWallet={amountWallet}
          setAmountWallet={setAmountWallet}
          amountBankTransfer={amountBankTransfer}
          setAmountBankTransfer={setAmountBankTransfer}
          setAmountToPayWithExtracredit={setAmountToPayWithExtracredit}
          walletBalanceValue={walletBalanceValue}
          setPage={setPage}
          maxInputAmountWallet={maxInputAmountWallet}
          maxInputAmountBankTransfer={maxInputAmountBankTransfer}
          uploadFile={uploadFile}
          fileUploadRef={fileUploadRef}
          cashback={cashback}
          showErrorToast={showErrorToast}
          page={page}
          loading={loading}
          hasCompleteAddress={hasCompleteAddress}
          isServiceOrDownloadable={() => {
            if (isFringeBenefitsPage) return false;

            return order.itens.some((item) => item.product.service || item.product.downloadable);
          }}
          isPickup={isPickup}
          userInfo={userInfo}
        />
      </div>
    </div>
  );
};

export default ShippingCheckout;
